import Vue from 'vue';

export const useTranslations = () => ({
  $t: Vue.i18n.translate,
  $i18n: Vue.i18n,
});
